export interface EmployeeContact {
  id: string;
  name: string;
  role: string;
  email: string;
  phoneNumber?: string;
  isPrimary: boolean;
  disabled: boolean;
}

export interface EmployeeUser {
  userId: string;
  username: string;
  userEmail: string;
  userPhoneNumber?: string;
  lastActive?: string;
  managedByCompany: boolean;
}

export interface EmployeeInvite {
  id: string;
  sentAt: string;
  accepted: boolean;
}

export interface Employee {
  id: string;
  isNew: boolean;
  contact?: EmployeeContact;
  user?: EmployeeUser;
  invite?: EmployeeInvite;
}

export interface EmployeeListItem extends Employee {
  joinRequest?: JoinRequestItem
}

export interface EmployeeQueryParams {
  page: number;
  pageSize: number;
  search?: string;
  companyId: string;
}

export interface EmployeeResponse {
  data: Employee[];
  total: number;
  page: number;
  pageSize: number;
}

export interface JoinRequestItem {
  id: string;
  userId: string;
  userName: string;
  userEmail: string;
  message?: string;
  createdAt: string;
}

export interface ListJoinRequestsResponse {
  data: JoinRequestItem[];
}

export interface CreateEmployeeData {
  firstName: string;
  lastName: string;
  phoneNumber?: string;
  email: string;
  roleId: string;
  isMainContact: boolean;
}

export interface AcceptJoinRequestRequest {
  joinRequestId: string;
  contact: CreateEmployeeData;
}

export interface JoinRequestInfo {
  id: string;
  userName: string;
  userEmail: string;
}

export enum JoinRequestStatus {
  PENDING = 'PENDING',
  ACCEPTED = 'ACCEPTED',
  REJECTED = 'REJECTED',
  CANCELLED = 'CANCELLED',
}

export interface JoinRequestResponse {
  id: string;
  companyId: string;
  requestingUserId: string;
  message?: string;
  status: JoinRequestStatus;
  createdAt: string;
  resolvedAt?: string;
  resolvedByUserId?: string;
}

// A user account that gets linked to an employee contact instead of an email invite
export interface LinkedUser {
  userId: string;
  username: string;
  email: string;
}
